module.exports = __webpack_public_path__ + "static/media/YL_howtoyieldlock_Desktop_EN.a57ce22e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YL_howtoyieldlock_Desktop_EN.png
// module id = 706
// module chunks = 0